import React, { useEffect, useState } from "react";
import { store } from "../../store";
import { apiLabs, apiLabsV2 } from "../../Services/api";
import history from "../../Services/history";
import Denied from "../../Components/Denied";
import Dashboard from "../../Components/Dashboard";
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { toast } from "react-toastify";
import useStyle from "./style";
import { DetailsSeal } from "../AddSeal/DetailsSeal";
import { Close } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";

const ListSeals = (props) => {
  const {
    location: { idPage },
  } = props;

  const [auth, setAuth] = useState(null);
  const [fullscreen] = useState(false);

  const [seals, setSeals] = useState({
    active: [],
    inactive: [],
  });

  const [flags, setFlags] = useState([]);

  const [editSeal, setEditSeal] = useState({});

  const [openModal, setOpenModal] = useState(false);
  const [openModalImport, setOpenModalImport] = useState(false);
  const [openModalExcludeProducts, setOpenModalExcludeProducts] =
    useState(false);
  const [openModalImage, setOpenModalImage] = useState(false);

  const [loading, setLoading] = useState(true);

  const style = useStyle();

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const handleEditSeal = async (id) => {
    try {
      const response = await apiLabsV2.get(`/flags/${id}`);

      const data = response.data[0];

      const [dateStart, timeStart] = data.date_start.split("T");
      const [dateEnd, timeSEnd] = data.date_end.split("T");

      setEditSeal({
        id,
        title: data.title,
        description: data.description,
        date_start: dateStart,
        date_end: dateEnd,
        type: data.type,
        color: data.color,
        background: data.background,
        status: data.status === 1 ? "ativar" : "inativo",
        image: data.image,
        csv: "",
        time_start: timeStart.slice(0, 5),
        time_end: timeSEnd.slice(0, 5),
      });
      setFlags([]);
      setOpenModal(true);

      const resposeProducts = await apiLabsV2.get(`/products/flags/${id}`);

      setFlags(resposeProducts.data);
      setLoading(false);
    } catch (error) {
      toast(error, { appearance: "error" });
      console.error(error);
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      await apiLabsV2.delete(`/flag/${editSeal.id}/sku/${id}`);
      const newItems = flags.filter((item) => item.sku !== id);
      setFlags(newItems);

      toast.success("Produto excluido com sucesso");
    } catch (error) {
      toast(error, { appearance: "error" });
      console.error(error);
    }
  };

  const handleAddFlag = async (event) => {
    try {
      setLoading(true);
      const file = event.target.files[0];

      const formData = new FormData();
      formData.append("csv", file);

      const response = await apiLabsV2.put(`/flags/${editSeal.id}`, formData);
      console.log(response);

      const resposeProducts = await apiLabsV2.get(
        `/products/flags/${editSeal.id}`
      );

      setFlags(resposeProducts.data);

      setLoading(false);

      toast.success("Selo adicionado com sucesso");
    } catch (error) {
      toast(error, { appearance: "error" });
      console.error(error);
    }
  };

  const handleExcludeFlag = async (event) => {
    try {
      setLoading(true);
      const file = event.target.files[0];

      const formData = new FormData();
      formData.append("csv_excludes", file);

      const response = await apiLabsV2.put(`/flags/${editSeal.id}`, formData);
      console.log(response);
      setOpenModalExcludeProducts(false);

      await timeout(3000);

      if (response.data) {
        const resposeProducts = await apiLabsV2.get(
          `/products/flags/${editSeal.id}`
        );

        console.log("teste");

        setFlags(resposeProducts.data);

        setLoading(false);
      }

      toast.success("Produtos excluidos com sucesso");
    } catch (error) {
      toast(error, { appearance: "error" });
      console.error(error);
    }
  };

  useEffect(() => {
    async function verifyAuth() {
      const { profile } = store.getState().user;
      const res = await apiLabs.post("valid_key", {
        id: profile.id,
        menu_id: idPage,
      });
      if (res.data.message === "User not authorized") {
        return setAuth("denied");
      }
      if (res.data.message === "User authorized") {
        return setAuth("authorized");
      }
      return history.push({ pathname: "/", state: { from: props.location } });
    }

    verifyAuth();
  }, [idPage, props.location]);

  useEffect(() => {
    const getSeals = async () => {
      try {
        const response = await apiLabsV2.get("/flags");

        setSeals({
          active: response.data
            .filter((seal) => seal.status === 1)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
          inactive: response.data
            .filter((seal) => seal.status === 0)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)),
        });
      } catch (error) {
        console.log(error.response);
      }
    };

    getSeals();
  }, []);

  console.log({ editSeal });

  return (
    <Dashboard title="Ativar/Desativar Selos" fullscreen={fullscreen}>
      {auth === "denied" && <Denied />}
      {auth === "authorized" && (
        <>
          <Container>
            <Grid container className={style.wrapperSeals}>
              <Grid spacing={2} className={style.wrapperTitle}>
                <Typography variant="h1">Ativar/Desativar Selos</Typography>
                <Typography variant="span">
                  Edite os selos ativos e inativos abaixo
                </Typography>
              </Grid>

              <Grid className={style.wrapperSealsActive}>
                <Typography variant="h2">Selos Ativos</Typography>

                {seals.active.length === 0 && (
                  <Typography variant="h6">Nenhum selo ativo</Typography>
                )}

                <Container className="seals">
                  {seals.active.map((seal) => (
                    <Card key={seal.id} className={style.cardSeals}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_22292_53683)">
                          <path
                            d="M23.1332 13.7555C22.9182 14.0059 22.7717 14.3076 22.708 14.6314C22.6443 14.9552 22.6655 15.29 22.7696 15.6031C22.8293 15.7976 22.8603 15.9997 22.8616 16.2031C22.8629 16.5587 22.7651 16.9076 22.5793 17.2107C22.3934 17.5138 22.1267 17.7591 21.8092 17.9191C21.5134 18.0666 21.2612 18.2885 21.0772 18.5632C20.8934 18.8373 20.7832 19.1541 20.7572 19.4832V19.4872C20.7249 19.9453 20.5283 20.3764 20.2035 20.7012C19.8788 21.026 19.4478 21.2227 18.9896 21.2551H18.9856C18.6564 21.2812 18.3395 21.3916 18.0654 21.5759C17.7914 21.7602 17.5695 22.0121 17.4212 22.3071C17.2603 22.6247 17.0142 22.8913 16.7104 23.0771C16.4067 23.2629 16.0573 23.3605 15.7012 23.3591C15.4991 23.358 15.2983 23.327 15.1052 23.2671C14.9115 23.2038 14.709 23.1714 14.5052 23.1712C14.0476 23.1695 13.6047 23.3328 13.2576 23.6311L13.2532 23.6352C12.9049 23.9348 12.4607 24.0995 12.0012 24.0995C11.5418 24.0995 11.0976 23.9348 10.7492 23.6352L10.7452 23.6311C10.4948 23.4161 10.193 23.2696 9.86917 23.2058C9.54533 23.142 9.21049 23.1632 8.89724 23.2671C8.70282 23.327 8.50067 23.358 8.29724 23.3591C7.94179 23.3604 7.59301 23.2627 7.28999 23.0769C6.98696 22.8911 6.74168 22.6245 6.58164 22.3071C6.43421 22.0114 6.21225 21.7591 5.93764 21.5751C5.66346 21.3914 5.34666 21.2812 5.01764 21.2551H5.01364C4.55545 21.2226 4.12437 21.0259 3.79953 20.7011C3.47469 20.3764 3.27788 19.9453 3.24524 19.4872V19.4832C3.21949 19.154 3.10914 18.8371 2.92489 18.5632C2.74065 18.2892 2.48876 18.0675 2.19364 17.9195C1.87606 17.7586 1.60948 17.5125 1.4237 17.2087C1.23793 16.905 1.14027 16.5556 1.14164 16.1995C1.14261 15.9974 1.17362 15.7966 1.23364 15.6035C1.29677 15.4098 1.32916 15.2073 1.32964 15.0035C1.33108 14.5459 1.1678 14.1031 0.869643 13.7559L0.865643 13.7519C0.565502 13.4039 0.400391 12.9596 0.400391 12.4999C0.400391 12.0403 0.565502 11.596 0.865643 11.2479L0.869643 11.2439C1.08456 10.9936 1.23103 10.6918 1.29481 10.3681C1.3586 10.0443 1.33752 9.70955 1.23364 9.39635C1.17363 9.20196 1.14263 8.99979 1.14164 8.79635C1.14028 8.44083 1.23798 8.09196 1.4238 7.78886C1.60962 7.48576 1.8762 7.24042 2.19364 7.08035C2.48933 6.9329 2.74148 6.71094 2.92524 6.43635C3.10922 6.16229 3.21943 5.84542 3.24524 5.51635V5.51235C3.27798 5.05424 3.47482 4.6233 3.79965 4.29861C4.12449 3.97392 4.55552 3.77727 5.01364 3.74475H5.01764C5.34679 3.71867 5.66365 3.60816 5.93762 3.42388C6.21159 3.2396 6.43341 2.98778 6.58164 2.69275C6.7426 2.37516 6.9887 2.10859 7.29244 1.92281C7.59618 1.73703 7.9456 1.63938 8.30164 1.64075C8.50375 1.64194 8.70458 1.67294 8.89764 1.73275C9.09137 1.79603 9.29385 1.82843 9.49764 1.82875C9.95543 1.83054 10.3985 1.66722 10.7456 1.36875L10.7496 1.36475C11.098 1.06515 11.5422 0.900391 12.0016 0.900391C12.4611 0.900391 12.9053 1.06515 13.2536 1.36475L13.258 1.36875C13.5084 1.58373 13.8101 1.73025 14.1339 1.79404C14.4577 1.85782 14.7925 1.83671 15.1056 1.73275C15.3001 1.67291 15.5022 1.64191 15.7056 1.64075C16.0612 1.63929 16.4101 1.73696 16.7132 1.92279C17.0163 2.10861 17.2616 2.37524 17.4216 2.69275C17.5692 2.98856 17.7913 3.24084 18.066 3.42475C18.3402 3.60859 18.657 3.7188 18.986 3.74475H18.99C19.4481 3.77721 19.8791 3.97386 20.2038 4.29858C20.5285 4.6233 20.7252 5.05428 20.7576 5.51235V5.51635C20.7837 5.8455 20.8942 6.16236 21.0785 6.43633C21.2628 6.7103 21.5146 6.93211 21.8096 7.08035C22.1273 7.24125 22.394 7.48733 22.5798 7.79107C22.7657 8.09482 22.8634 8.44426 22.862 8.80035C22.8607 9.00244 22.8297 9.20324 22.77 9.39635C22.7064 9.59 22.6739 9.79251 22.6736 9.99635C22.672 10.454 22.8353 10.8969 23.1336 11.2439L23.138 11.2479C23.4372 11.5975 23.6012 12.0426 23.6003 12.5026C23.5994 12.9627 23.4337 13.4072 23.1332 13.7555Z"
                            fill="white"
                          />
                          <path
                            d="M12.0002 21.2992C16.8603 21.2992 20.8002 17.3593 20.8002 12.4992C20.8002 7.63911 16.8603 3.69922 12.0002 3.69922C7.14009 3.69922 3.2002 7.63911 3.2002 12.4992C3.2002 17.3593 7.14009 21.2992 12.0002 21.2992Z"
                            fill="#107C41"
                          />
                          <path
                            d="M0.928979 15.0038C0.928162 15.168 0.901156 15.331 0.848979 15.4866C0.77791 15.7176 0.741118 15.9578 0.739779 16.1994C0.737674 16.6298 0.855681 17.0523 1.08053 17.4193C1.30538 17.7864 1.62816 18.0834 2.01258 18.277C2.24624 18.3946 2.44559 18.5706 2.59135 18.7878C2.7371 19.005 2.82432 19.2562 2.84458 19.517C2.88663 20.0708 3.12591 20.5911 3.51897 20.9834C3.91202 21.3757 4.43276 21.614 4.98658 21.655C5.24649 21.676 5.49664 21.7635 5.71298 21.909C5.93065 22.0544 6.10648 22.2542 6.22298 22.4886C6.41606 22.8723 6.71234 23.1946 7.07851 23.4191C7.44468 23.6437 7.86623 23.7617 8.29578 23.7598C8.54184 23.7584 8.78634 23.7207 9.02138 23.6478C9.26285 23.5673 9.52071 23.549 9.77113 23.5945C10.0216 23.64 10.2565 23.7479 10.4542 23.9082C10.4634 23.9174 10.4766 23.9306 10.4866 23.9394C10.9061 24.3044 11.4435 24.5054 11.9996 24.5054C12.5557 24.5054 13.093 24.3044 13.5126 23.9394L13.5278 23.9258C13.7267 23.7582 13.9656 23.6448 14.2213 23.5966C14.4769 23.5485 14.7407 23.5672 14.987 23.651C15.5146 23.8187 16.0846 23.7938 16.5956 23.5807C17.1066 23.3675 17.5253 22.98 17.7774 22.487C17.895 22.2534 18.0709 22.054 18.2882 21.9083C18.5054 21.7625 18.7566 21.6753 19.0174 21.655C19.5713 21.6131 20.0917 21.3738 20.4841 20.9806C20.8765 20.5875 21.1148 20.0666 21.1558 19.5126C21.1768 19.2533 21.2638 19.0036 21.4086 18.7874C21.5544 18.5697 21.7546 18.3939 21.9894 18.2774C22.3731 18.0843 22.6953 17.788 22.9198 17.4219C23.1444 17.0557 23.2624 16.6342 23.2606 16.2046C23.2591 15.9586 23.2214 15.7141 23.1486 15.479C23.0671 15.2312 23.0507 14.9666 23.1011 14.7106C23.1514 14.4546 23.2668 14.2159 23.4362 14.0174C23.7967 13.5953 23.9951 13.0587 23.9959 12.5036C23.9966 11.9485 23.7996 11.4113 23.4402 10.9882C23.4362 10.9834 23.431 10.9782 23.4262 10.973C23.1968 10.6998 23.0716 10.3542 23.073 9.99742C23.0736 9.83299 23.1007 9.66972 23.153 9.51382C23.2237 9.28291 23.2603 9.04292 23.2618 8.80142C23.2639 8.371 23.1459 7.94853 22.921 7.5815C22.6962 7.21448 22.3734 6.91745 21.989 6.72382C21.7554 6.60605 21.5562 6.43007 21.4105 6.21287C21.2647 5.99567 21.1774 5.74458 21.157 5.48382C21.115 4.93001 20.8758 4.40962 20.4827 4.01722C20.0897 3.62482 19.5689 3.38645 19.015 3.34542C18.7553 3.32476 18.5053 3.23771 18.289 3.09262C18.0708 2.94712 17.8946 2.74683 17.7782 2.51182C17.585 2.12825 17.2887 1.80614 16.9225 1.58165C16.5563 1.35717 16.1349 1.23921 15.7054 1.24102C15.4592 1.24244 15.2146 1.28018 14.9794 1.35302C14.7307 1.43438 14.4653 1.45032 14.2086 1.39932C13.952 1.34832 13.7128 1.23209 13.5142 1.06182C13.0938 0.696254 12.5553 0.495287 11.9982 0.496096C11.4411 0.496905 10.9031 0.699435 10.4838 1.06622C10.2845 1.23675 10.0443 1.35258 9.78671 1.40237C9.52916 1.45215 9.2631 1.43418 9.01458 1.35022C8.48681 1.18425 7.91738 1.20997 7.40672 1.42286C6.89606 1.63574 6.47697 2.02211 6.22338 2.51382C6.1057 2.74741 5.92975 2.94668 5.71252 3.09236C5.49529 3.23805 5.24415 3.32521 4.98338 3.34542C4.42971 3.38778 3.90955 3.62716 3.51723 4.02014C3.12491 4.41312 2.88641 4.93368 2.84498 5.48742C2.82395 5.74707 2.73678 5.99701 2.59178 6.21342C2.44622 6.43124 2.2461 6.60708 2.01138 6.72342C1.6277 6.91654 1.30548 7.21283 1.08092 7.57899C0.856358 7.94516 0.738358 8.36669 0.740179 8.79622C0.741745 9.04227 0.779482 9.28676 0.852179 9.52182C0.933812 9.7704 0.9499 10.0358 0.898885 10.2925C0.847871 10.5491 0.731481 10.7882 0.560979 10.9866C0.195329 11.407 -0.0056893 11.9455 -0.00488038 12.5027C-0.00407146 13.0598 0.19851 13.5977 0.565379 14.017C0.800971 14.2917 0.930011 14.6419 0.928979 15.0038ZM1.17258 11.5046C1.43059 11.203 1.6069 10.8402 1.68463 10.451C1.76237 10.0617 1.73894 9.65903 1.61658 9.28142C1.56803 9.12421 1.5427 8.96076 1.54138 8.79622C1.53992 8.51536 1.61668 8.23964 1.76306 7.99994C1.90944 7.76023 2.11966 7.56601 2.37018 7.43902C2.72943 7.26027 3.03569 6.99069 3.25858 6.65702C3.48117 6.32404 3.614 5.93922 3.64418 5.53982C3.66837 5.17603 3.82424 4.8335 4.08264 4.57628C4.34104 4.31906 4.68428 4.16476 5.04818 4.14222C5.44565 4.11029 5.82824 3.97672 6.15921 3.75432C6.49019 3.53192 6.75843 3.22816 6.93818 2.87222C7.0655 2.6205 7.26047 2.40926 7.5012 2.26222C7.74194 2.11518 8.0189 2.03817 8.30098 2.03982C8.4611 2.04081 8.62023 2.06507 8.77338 2.11182C9.15311 2.23493 9.55804 2.25875 9.94958 2.18103C10.3411 2.10331 10.7063 1.92663 11.0102 1.66782C11.2859 1.42828 11.639 1.29673 12.0042 1.29754C12.3694 1.29835 12.722 1.43146 12.9966 1.67222C13.2983 1.9303 13.6613 2.10662 14.0507 2.18429C14.4401 2.26196 14.8429 2.23838 15.2206 2.11582C15.5667 2.00012 15.9428 2.01255 16.2806 2.15087C16.6183 2.28918 16.8951 2.54418 17.0606 2.86942C17.2393 3.22879 17.5089 3.53518 17.8426 3.75822C18.1753 3.98039 18.5597 4.11305 18.9586 4.14342C19.3224 4.16761 19.665 4.32346 19.9223 4.58185C20.1796 4.84024 20.334 5.18349 20.3566 5.54742C20.3885 5.94486 20.522 6.32741 20.7444 6.65833C20.9668 6.98925 21.2706 7.2574 21.6266 7.43702C21.8782 7.56463 22.0893 7.75972 22.2363 8.00048C22.3833 8.24123 22.4604 8.51814 22.459 8.80022C22.4579 8.96005 22.4338 9.11888 22.3874 9.27182C22.2628 9.65059 22.2379 10.055 22.3149 10.4462C22.392 10.8374 22.5685 11.2022 22.8274 11.5054L22.8406 11.5198C23.0718 11.7976 23.1973 12.1483 23.1948 12.5097C23.1923 12.8711 23.062 13.22 22.827 13.4946C22.5691 13.7963 22.3929 14.1592 22.3153 14.5484C22.2378 14.9376 22.2613 15.3403 22.3838 15.7178C22.4323 15.875 22.4575 16.0385 22.4586 16.203C22.46 16.4839 22.3832 16.7596 22.2368 16.9993C22.0905 17.239 21.8803 17.4332 21.6298 17.5602C21.2716 17.7396 20.9663 18.009 20.7437 18.3421C20.5211 18.6751 20.3889 19.0603 20.3602 19.4598C20.3359 19.8236 20.18 20.1661 19.9216 20.4233C19.6632 20.6805 19.3201 20.8348 18.9562 20.8574C18.5586 20.8893 18.176 21.0228 17.8449 21.2452C17.5139 21.4676 17.2456 21.7714 17.0658 22.1274C16.9385 22.3792 16.7435 22.5904 16.5028 22.7375C16.2621 22.8845 15.9851 22.9615 15.703 22.9598C15.543 22.9587 15.3841 22.9346 15.231 22.8882C14.852 22.7654 14.4479 22.7413 14.0571 22.8183C13.6662 22.8953 13.3014 23.0708 12.9974 23.3282L12.983 23.3418C12.7135 23.574 12.3704 23.7031 12.0147 23.7062C11.659 23.7094 11.3138 23.5864 11.0402 23.359C11.031 23.3494 11.0174 23.3362 11.0074 23.3274C10.5857 22.9677 10.0496 22.7701 9.49538 22.7702C9.25388 22.77 9.0139 22.8085 8.78458 22.8842C8.43809 23.0013 8.06102 22.9895 7.72254 22.851C7.38405 22.7125 7.10685 22.4566 6.94178 22.1302C6.76306 21.771 6.49364 21.4646 6.16018 21.2414C5.82732 21.0192 5.44282 20.8866 5.04378 20.8562C4.67997 20.832 4.33744 20.6761 4.08017 20.4177C3.8229 20.1593 3.66849 19.8161 3.64578 19.4522C3.61392 19.0547 3.48038 18.6721 3.25797 18.3411C3.03556 18.0101 2.73177 17.7419 2.37578 17.5622C2.12403 17.4349 1.91276 17.24 1.76571 16.9992C1.61867 16.7585 1.54167 16.4815 1.54338 16.1994C1.54443 16.0396 1.56868 15.8807 1.61538 15.7278C1.69196 15.4941 1.73098 15.2498 1.73098 15.0038C1.73264 14.4486 1.53378 13.9114 1.17098 13.491C0.931047 13.2157 0.799004 12.8627 0.799299 12.4975C0.799593 12.1323 0.932204 11.7796 1.17258 11.5046Z"
                            fill="#33C481"
                          />
                          <path
                            d="M12 21.7008C13.4749 21.7007 14.9282 21.346 16.2373 20.6666C17.5464 19.9872 18.673 19.0031 19.5221 17.7971C20.3712 16.5911 20.9178 15.1986 21.116 13.7371C21.3143 12.2756 21.1582 10.7879 20.661 9.39929C20.1637 8.01073 19.34 6.76206 18.2591 5.75855C17.1782 4.75504 15.8719 4.02612 14.4503 3.63322C13.0287 3.24032 11.5334 3.19497 10.0906 3.50099C8.64784 3.80701 7.29975 4.45543 6.16004 5.39158C6.07861 5.45911 6.02725 5.55615 6.01719 5.66145C6.00713 5.76676 6.0392 5.87176 6.10637 5.95348C6.17355 6.0352 6.27036 6.08699 6.37562 6.0975C6.48089 6.10801 6.58603 6.0764 6.66804 6.00958C8.33554 4.63934 10.4664 3.96326 12.6188 4.12148C14.7713 4.2797 16.7803 5.2601 18.2296 6.85945C19.6788 8.4588 20.457 10.5545 20.403 12.7121C20.3489 14.8696 19.4668 16.9237 17.9393 18.4485C16.4119 19.9733 14.3562 20.8519 12.1986 20.9022C10.0409 20.9525 7.94656 20.1706 6.34974 18.7186C4.75292 17.2666 3.77603 15.2558 3.62156 13.1031C3.46709 10.9503 4.14689 8.82069 5.52004 7.15558C5.58762 7.07379 5.61993 6.9685 5.60988 6.86288C5.59983 6.75726 5.54823 6.65996 5.46644 6.59238C5.38465 6.5248 5.27936 6.49249 5.17374 6.50254C5.06812 6.51259 4.97082 6.56419 4.90324 6.64598C3.79288 7.99184 3.08812 9.6257 2.87119 11.3569C2.65427 13.0882 2.93411 14.8454 3.67808 16.4236C4.42204 18.0018 5.59946 19.336 7.07295 20.2703C8.54645 21.2047 10.2553 21.7008 12 21.7008Z"
                            fill="#33C481"
                          />
                          <path
                            d="M9.99992 16.5003H10.0247C10.0814 16.4968 10.1366 16.4813 10.1869 16.4548C10.2371 16.4283 10.2811 16.3915 10.3159 16.3467L15.9159 9.14668C15.9496 9.10537 15.9746 9.05776 15.9896 9.00664C16.0046 8.95552 16.0092 8.90192 16.0032 8.849C15.9972 8.79607 15.9806 8.74487 15.9546 8.69842C15.9285 8.65196 15.8934 8.61118 15.8514 8.57846C15.8093 8.54575 15.7612 8.52176 15.7098 8.50791C15.6583 8.49405 15.6046 8.49061 15.5519 8.49778C15.4991 8.50496 15.4482 8.5226 15.4024 8.54968C15.3565 8.57676 15.3165 8.61273 15.2847 8.65548L9.96472 15.4979L8.68472 14.2179C8.60928 14.145 8.50824 14.1047 8.40336 14.1056C8.29848 14.1065 8.19816 14.1486 8.12399 14.2228C8.04983 14.2969 8.00776 14.3972 8.00685 14.5021C8.00594 14.607 8.04626 14.708 8.11912 14.7835L9.71912 16.3835C9.79369 16.4579 9.89459 16.4998 9.99992 16.5003Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_22292_53683">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div>
                        <p>{seal.title}</p>
                        <span>
                          De {seal.date_start.split(" ")[0]} a{" "}
                          {seal.date_end.split(" ")[0]}
                        </span>
                      </div>

                      <Button onClick={() => handleEditSeal(seal.id)}>
                        <EditIcon width={20} />
                      </Button>
                    </Card>
                  ))}
                </Container>
              </Grid>

              <Grid className={style.wrapperSealsActive}>
                <Typography variant="h2">Selos Inativos</Typography>

                {seals.inactive.length === 0 && (
                  <Typography variant="h6">Nenhum selo inativo</Typography>
                )}

                <Container className="seals">
                  {seals.inactive.map((seal) => (
                    <Card key={seal.id} className={style.cardSeals}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_22292_53712)">
                          <path
                            d="M23.1332 13.7555C22.9182 14.0059 22.7717 14.3076 22.708 14.6314C22.6443 14.9552 22.6655 15.29 22.7696 15.6031C22.8293 15.7976 22.8603 15.9997 22.8616 16.2031C22.8629 16.5587 22.7651 16.9076 22.5793 17.2107C22.3934 17.5138 22.1267 17.7591 21.8092 17.9191C21.5134 18.0666 21.2612 18.2885 21.0772 18.5632C20.8934 18.8373 20.7832 19.1541 20.7572 19.4832V19.4872C20.7249 19.9453 20.5283 20.3764 20.2035 20.7012C19.8788 21.026 19.4478 21.2227 18.9896 21.2551H18.9856C18.6564 21.2812 18.3395 21.3916 18.0654 21.5759C17.7914 21.7602 17.5695 22.0121 17.4212 22.3071C17.2603 22.6247 17.0142 22.8913 16.7104 23.0771C16.4067 23.2629 16.0573 23.3605 15.7012 23.3591C15.4991 23.358 15.2983 23.327 15.1052 23.2671C14.9115 23.2038 14.709 23.1714 14.5052 23.1712C14.0476 23.1695 13.6047 23.3328 13.2576 23.6311L13.2532 23.6352C12.9049 23.9348 12.4607 24.0995 12.0012 24.0995C11.5418 24.0995 11.0976 23.9348 10.7492 23.6352L10.7452 23.6311C10.4948 23.4161 10.193 23.2696 9.86917 23.2058C9.54533 23.142 9.21049 23.1632 8.89724 23.2671C8.70282 23.327 8.50067 23.358 8.29724 23.3591C7.94179 23.3604 7.59301 23.2627 7.28999 23.0769C6.98696 22.8911 6.74168 22.6245 6.58164 22.3071C6.43421 22.0114 6.21225 21.7591 5.93764 21.5751C5.66346 21.3914 5.34666 21.2812 5.01764 21.2551H5.01364C4.55545 21.2226 4.12437 21.0259 3.79953 20.7011C3.47469 20.3764 3.27788 19.9453 3.24524 19.4872V19.4832C3.21949 19.154 3.10914 18.8371 2.92489 18.5632C2.74065 18.2892 2.48876 18.0675 2.19364 17.9195C1.87606 17.7586 1.60948 17.5125 1.4237 17.2087C1.23793 16.905 1.14027 16.5556 1.14164 16.1995C1.14261 15.9974 1.17362 15.7966 1.23364 15.6035C1.29677 15.4098 1.32916 15.2073 1.32964 15.0035C1.33108 14.5459 1.1678 14.1031 0.869643 13.7559L0.865643 13.7519C0.565502 13.4039 0.400391 12.9596 0.400391 12.4999C0.400391 12.0403 0.565502 11.596 0.865643 11.2479L0.869643 11.2439C1.08456 10.9936 1.23103 10.6918 1.29481 10.3681C1.3586 10.0443 1.33752 9.70955 1.23364 9.39635C1.17363 9.20196 1.14263 8.99979 1.14164 8.79635C1.14028 8.44083 1.23798 8.09196 1.4238 7.78886C1.60962 7.48576 1.8762 7.24042 2.19364 7.08035C2.48933 6.9329 2.74148 6.71094 2.92524 6.43635C3.10922 6.16229 3.21943 5.84542 3.24524 5.51635V5.51235C3.27798 5.05424 3.47482 4.6233 3.79965 4.29861C4.12449 3.97392 4.55552 3.77727 5.01364 3.74475H5.01764C5.34679 3.71867 5.66365 3.60816 5.93762 3.42388C6.21159 3.2396 6.43341 2.98778 6.58164 2.69275C6.7426 2.37516 6.9887 2.10859 7.29244 1.92281C7.59618 1.73703 7.9456 1.63938 8.30164 1.64075C8.50375 1.64194 8.70458 1.67294 8.89764 1.73275C9.09137 1.79603 9.29385 1.82843 9.49764 1.82875C9.95543 1.83054 10.3985 1.66722 10.7456 1.36875L10.7496 1.36475C11.098 1.06515 11.5422 0.900391 12.0016 0.900391C12.4611 0.900391 12.9053 1.06515 13.2536 1.36475L13.258 1.36875C13.5084 1.58373 13.8101 1.73025 14.1339 1.79404C14.4577 1.85782 14.7925 1.83671 15.1056 1.73275C15.3001 1.67291 15.5022 1.64191 15.7056 1.64075C16.0612 1.63929 16.4101 1.73696 16.7132 1.92279C17.0163 2.10861 17.2616 2.37524 17.4216 2.69275C17.5692 2.98856 17.7913 3.24084 18.066 3.42475C18.3402 3.60859 18.657 3.7188 18.986 3.74475H18.99C19.4481 3.77721 19.8791 3.97386 20.2038 4.29858C20.5285 4.6233 20.7252 5.05428 20.7576 5.51235V5.51635C20.7837 5.8455 20.8942 6.16236 21.0785 6.43633C21.2628 6.7103 21.5146 6.93211 21.8096 7.08035C22.1273 7.24125 22.394 7.48733 22.5798 7.79107C22.7657 8.09482 22.8634 8.44426 22.862 8.80035C22.8607 9.00244 22.8297 9.20324 22.77 9.39635C22.7064 9.59 22.6739 9.79251 22.6736 9.99635C22.672 10.454 22.8353 10.8969 23.1336 11.2439L23.138 11.2479C23.4372 11.5975 23.6012 12.0426 23.6003 12.5026C23.5994 12.9627 23.4337 13.4072 23.1332 13.7555Z"
                            fill="white"
                          />
                          <path
                            d="M12.0002 21.2992C16.8603 21.2992 20.8002 17.3593 20.8002 12.4992C20.8002 7.63911 16.8603 3.69922 12.0002 3.69922C7.14009 3.69922 3.2002 7.63911 3.2002 12.4992C3.2002 17.3593 7.14009 21.2992 12.0002 21.2992Z"
                            fill="#B01010"
                          />
                          <path
                            d="M0.928979 15.0038C0.928162 15.168 0.901156 15.331 0.848979 15.4866C0.77791 15.7176 0.741118 15.9578 0.739779 16.1994C0.737674 16.6298 0.855681 17.0523 1.08053 17.4193C1.30538 17.7864 1.62816 18.0834 2.01258 18.277C2.24624 18.3946 2.44559 18.5706 2.59135 18.7878C2.7371 19.005 2.82432 19.2562 2.84458 19.517C2.88663 20.0708 3.12591 20.5911 3.51897 20.9834C3.91202 21.3757 4.43276 21.614 4.98658 21.655C5.24649 21.676 5.49664 21.7635 5.71298 21.909C5.93065 22.0544 6.10648 22.2542 6.22298 22.4886C6.41606 22.8723 6.71234 23.1946 7.07851 23.4191C7.44468 23.6437 7.86623 23.7617 8.29578 23.7598C8.54184 23.7584 8.78634 23.7207 9.02138 23.6478C9.26285 23.5673 9.52071 23.549 9.77113 23.5945C10.0216 23.64 10.2565 23.7479 10.4542 23.9082C10.4634 23.9174 10.4766 23.9306 10.4866 23.9394C10.9061 24.3044 11.4435 24.5054 11.9996 24.5054C12.5557 24.5054 13.093 24.3044 13.5126 23.9394L13.5278 23.9258C13.7267 23.7582 13.9656 23.6448 14.2213 23.5966C14.4769 23.5485 14.7407 23.5672 14.987 23.651C15.5146 23.8187 16.0846 23.7938 16.5956 23.5807C17.1066 23.3675 17.5253 22.98 17.7774 22.487C17.895 22.2534 18.0709 22.054 18.2882 21.9083C18.5054 21.7625 18.7566 21.6753 19.0174 21.655C19.5713 21.6131 20.0917 21.3738 20.4841 20.9806C20.8765 20.5875 21.1148 20.0666 21.1558 19.5126C21.1768 19.2533 21.2638 19.0036 21.4086 18.7874C21.5544 18.5697 21.7546 18.3939 21.9894 18.2774C22.3731 18.0843 22.6953 17.788 22.9198 17.4219C23.1444 17.0557 23.2624 16.6342 23.2606 16.2046C23.2591 15.9586 23.2214 15.7141 23.1486 15.479C23.0671 15.2312 23.0507 14.9666 23.1011 14.7106C23.1514 14.4546 23.2668 14.2159 23.4362 14.0174C23.7967 13.5953 23.9951 13.0587 23.9959 12.5036C23.9966 11.9485 23.7996 11.4113 23.4402 10.9882C23.4362 10.9834 23.431 10.9782 23.4262 10.973C23.1968 10.6998 23.0716 10.3542 23.073 9.99742C23.0736 9.83299 23.1007 9.66972 23.153 9.51382C23.2237 9.28291 23.2603 9.04292 23.2618 8.80142C23.2639 8.371 23.1459 7.94853 22.921 7.5815C22.6962 7.21448 22.3734 6.91745 21.989 6.72382C21.7554 6.60605 21.5562 6.43007 21.4105 6.21287C21.2647 5.99567 21.1774 5.74458 21.157 5.48382C21.115 4.93001 20.8758 4.40962 20.4827 4.01722C20.0897 3.62482 19.5689 3.38645 19.015 3.34542C18.7553 3.32476 18.5053 3.23771 18.289 3.09262C18.0708 2.94712 17.8946 2.74683 17.7782 2.51182C17.585 2.12825 17.2887 1.80614 16.9225 1.58165C16.5563 1.35717 16.1349 1.23921 15.7054 1.24102C15.4592 1.24244 15.2146 1.28018 14.9794 1.35302C14.7307 1.43438 14.4653 1.45032 14.2086 1.39932C13.952 1.34832 13.7128 1.23209 13.5142 1.06182C13.0938 0.696254 12.5553 0.495287 11.9982 0.496096C11.4411 0.496905 10.9031 0.699435 10.4838 1.06622C10.2845 1.23675 10.0443 1.35258 9.78671 1.40237C9.52916 1.45215 9.2631 1.43418 9.01458 1.35022C8.48681 1.18425 7.91738 1.20997 7.40672 1.42286C6.89606 1.63574 6.47697 2.02211 6.22338 2.51382C6.1057 2.74741 5.92975 2.94668 5.71252 3.09236C5.49529 3.23805 5.24415 3.32521 4.98338 3.34542C4.42971 3.38778 3.90955 3.62716 3.51723 4.02014C3.12491 4.41312 2.88641 4.93368 2.84498 5.48742C2.82395 5.74707 2.73678 5.99701 2.59178 6.21342C2.44622 6.43124 2.2461 6.60708 2.01138 6.72342C1.6277 6.91654 1.30548 7.21283 1.08092 7.57899C0.856358 7.94516 0.738358 8.36669 0.740179 8.79622C0.741745 9.04227 0.779482 9.28676 0.852179 9.52182C0.933812 9.7704 0.9499 10.0358 0.898885 10.2925C0.847871 10.5491 0.731481 10.7882 0.560979 10.9866C0.195329 11.407 -0.0056893 11.9455 -0.00488038 12.5027C-0.00407146 13.0598 0.19851 13.5977 0.565379 14.017C0.800971 14.2917 0.930011 14.6419 0.928979 15.0038ZM1.17258 11.5046C1.43059 11.203 1.6069 10.8402 1.68463 10.451C1.76237 10.0617 1.73894 9.65903 1.61658 9.28142C1.56803 9.12421 1.5427 8.96076 1.54138 8.79622C1.53992 8.51536 1.61668 8.23964 1.76306 7.99994C1.90944 7.76023 2.11966 7.56601 2.37018 7.43902C2.72943 7.26027 3.03569 6.99069 3.25858 6.65702C3.48117 6.32404 3.614 5.93922 3.64418 5.53982C3.66837 5.17603 3.82424 4.8335 4.08264 4.57628C4.34104 4.31906 4.68428 4.16476 5.04818 4.14222C5.44565 4.11029 5.82824 3.97672 6.15921 3.75432C6.49019 3.53192 6.75843 3.22816 6.93818 2.87222C7.0655 2.6205 7.26047 2.40926 7.5012 2.26222C7.74194 2.11518 8.0189 2.03817 8.30098 2.03982C8.4611 2.04081 8.62023 2.06507 8.77338 2.11182C9.15311 2.23493 9.55804 2.25875 9.94958 2.18103C10.3411 2.10331 10.7063 1.92663 11.0102 1.66782C11.2859 1.42828 11.639 1.29673 12.0042 1.29754C12.3694 1.29835 12.722 1.43146 12.9966 1.67222C13.2983 1.9303 13.6613 2.10662 14.0507 2.18429C14.4401 2.26196 14.8429 2.23838 15.2206 2.11582C15.5667 2.00012 15.9428 2.01255 16.2806 2.15087C16.6183 2.28918 16.8951 2.54418 17.0606 2.86942C17.2393 3.22879 17.5089 3.53518 17.8426 3.75822C18.1753 3.98039 18.5597 4.11305 18.9586 4.14342C19.3224 4.16761 19.665 4.32346 19.9223 4.58185C20.1796 4.84024 20.334 5.18349 20.3566 5.54742C20.3885 5.94486 20.522 6.32741 20.7444 6.65833C20.9668 6.98925 21.2706 7.2574 21.6266 7.43702C21.8782 7.56463 22.0893 7.75972 22.2363 8.00048C22.3833 8.24123 22.4604 8.51814 22.459 8.80022C22.4579 8.96005 22.4338 9.11888 22.3874 9.27182C22.2628 9.65059 22.2379 10.055 22.3149 10.4462C22.392 10.8374 22.5685 11.2022 22.8274 11.5054L22.8406 11.5198C23.0718 11.7976 23.1973 12.1483 23.1948 12.5097C23.1923 12.8711 23.062 13.22 22.827 13.4946C22.5691 13.7963 22.3929 14.1592 22.3153 14.5484C22.2378 14.9376 22.2613 15.3403 22.3838 15.7178C22.4323 15.875 22.4575 16.0385 22.4586 16.203C22.46 16.4839 22.3832 16.7596 22.2368 16.9993C22.0905 17.239 21.8803 17.4332 21.6298 17.5602C21.2716 17.7396 20.9663 18.009 20.7437 18.3421C20.5211 18.6751 20.3889 19.0603 20.3602 19.4598C20.3359 19.8236 20.18 20.1661 19.9216 20.4233C19.6632 20.6805 19.3201 20.8348 18.9562 20.8574C18.5586 20.8893 18.176 21.0228 17.8449 21.2452C17.5139 21.4676 17.2456 21.7714 17.0658 22.1274C16.9385 22.3792 16.7435 22.5904 16.5028 22.7375C16.2621 22.8845 15.9851 22.9615 15.703 22.9598C15.543 22.9587 15.3841 22.9346 15.231 22.8882C14.852 22.7654 14.4479 22.7413 14.0571 22.8183C13.6662 22.8953 13.3014 23.0708 12.9974 23.3282L12.983 23.3418C12.7135 23.574 12.3704 23.7031 12.0147 23.7062C11.659 23.7094 11.3138 23.5864 11.0402 23.359C11.031 23.3494 11.0174 23.3362 11.0074 23.3274C10.5857 22.9677 10.0496 22.7701 9.49538 22.7702C9.25388 22.77 9.0139 22.8085 8.78458 22.8842C8.43809 23.0013 8.06102 22.9895 7.72254 22.851C7.38405 22.7125 7.10685 22.4566 6.94178 22.1302C6.76306 21.771 6.49364 21.4646 6.16018 21.2414C5.82732 21.0192 5.44282 20.8866 5.04378 20.8562C4.67997 20.832 4.33744 20.6761 4.08017 20.4177C3.8229 20.1593 3.66849 19.8161 3.64578 19.4522C3.61392 19.0547 3.48038 18.6721 3.25797 18.3411C3.03556 18.0101 2.73177 17.7419 2.37578 17.5622C2.12403 17.4349 1.91276 17.24 1.76571 16.9992C1.61867 16.7585 1.54167 16.4815 1.54338 16.1994C1.54443 16.0396 1.56868 15.8807 1.61538 15.7278C1.69196 15.4941 1.73098 15.2498 1.73098 15.0038C1.73264 14.4486 1.53378 13.9114 1.17098 13.491C0.931047 13.2157 0.799004 12.8627 0.799299 12.4975C0.799593 12.1323 0.932204 11.7796 1.17258 11.5046Z"
                            fill="#D81717"
                          />
                          <path
                            d="M12 21.7008C13.4749 21.7007 14.9282 21.346 16.2373 20.6666C17.5464 19.9872 18.673 19.0031 19.5221 17.7971C20.3712 16.5911 20.9178 15.1986 21.116 13.7371C21.3143 12.2756 21.1582 10.7879 20.661 9.39929C20.1637 8.01073 19.34 6.76206 18.2591 5.75855C17.1782 4.75504 15.8719 4.02612 14.4503 3.63322C13.0287 3.24032 11.5334 3.19497 10.0906 3.50099C8.64784 3.80701 7.29975 4.45543 6.16004 5.39158C6.07861 5.45911 6.02725 5.55615 6.01719 5.66145C6.00713 5.76676 6.0392 5.87176 6.10637 5.95348C6.17355 6.0352 6.27036 6.08699 6.37562 6.0975C6.48089 6.10801 6.58603 6.0764 6.66804 6.00958C8.33554 4.63934 10.4664 3.96326 12.6188 4.12148C14.7713 4.2797 16.7803 5.2601 18.2296 6.85945C19.6788 8.4588 20.457 10.5545 20.403 12.7121C20.3489 14.8696 19.4668 16.9237 17.9393 18.4485C16.4119 19.9733 14.3562 20.8519 12.1986 20.9022C10.0409 20.9525 7.94656 20.1706 6.34974 18.7186C4.75292 17.2666 3.77603 15.2558 3.62156 13.1031C3.46709 10.9503 4.14689 8.82069 5.52004 7.15558C5.58762 7.07379 5.61993 6.9685 5.60988 6.86288C5.59983 6.75726 5.54823 6.65996 5.46644 6.59238C5.38465 6.5248 5.27936 6.49249 5.17374 6.50254C5.06812 6.51259 4.97082 6.56419 4.90324 6.64598C3.79288 7.99184 3.08812 9.6257 2.87119 11.3569C2.65427 13.0882 2.93411 14.8454 3.67808 16.4236C4.42204 18.0018 5.59946 19.336 7.07295 20.2703C8.54645 21.2047 10.2553 21.7008 12 21.7008Z"
                            fill="#D81717"
                          />
                          <path
                            d="M9.99992 16.5003H10.0247C10.0814 16.4968 10.1366 16.4813 10.1869 16.4548C10.2371 16.4283 10.2811 16.3915 10.3159 16.3467L15.9159 9.14668C15.9496 9.10537 15.9746 9.05776 15.9896 9.00664C16.0046 8.95552 16.0092 8.90192 16.0032 8.849C15.9972 8.79607 15.9806 8.74487 15.9546 8.69842C15.9285 8.65196 15.8934 8.61118 15.8514 8.57846C15.8093 8.54575 15.7612 8.52176 15.7098 8.50791C15.6583 8.49405 15.6046 8.49061 15.5519 8.49778C15.4991 8.50496 15.4482 8.5226 15.4024 8.54968C15.3565 8.57676 15.3165 8.61273 15.2847 8.65548L9.96472 15.4979L8.68472 14.2179C8.60928 14.145 8.50824 14.1047 8.40336 14.1056C8.29848 14.1065 8.19816 14.1486 8.12399 14.2228C8.04983 14.2969 8.00776 14.3972 8.00685 14.5021C8.00594 14.607 8.04626 14.708 8.11912 14.7835L9.71912 16.3835C9.79369 16.4579 9.89459 16.4998 9.99992 16.5003Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_22292_53712">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div>
                        <p>{seal.title}</p>
                        <span>
                          De {seal.date_start.split(" ")[0]} a{" "}
                          {seal.date_end.split(" ")[0]}
                        </span>
                      </div>

                      <Button onClick={() => handleEditSeal(seal.id)}>
                        <EditIcon width={20} />
                      </Button>
                    </Card>
                  ))}
                </Container>
              </Grid>
            </Grid>
          </Container>

          <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={style.modalPreviewSeal}
          >
            <DialogContent className={style.dialogContent}>
              <Button
                className={style.modalClose}
                onClick={() => setOpenModal(false)}
              >
                <Close />
              </Button>
              <Grid className={style.wrapperSealExclud}>
                <Container className={style.containerImport}>
                  <Button onClick={() => setOpenModalImport(true)}>
                    Importar planilha
                  </Button>
                </Container>
                <Container className={style.containerSealExclud}>
                  {editSeal.image && (
                    <div className={style.sealExclud}>
                      <div data-element="seal">
                        <img
                          src={
                            typeof editSeal.image === "string"
                              ? editSeal.image
                              : editSeal.image &&
                                URL.createObjectURL(editSeal?.image)
                          }
                          alt={editSeal.title || "Seal image"}
                          width={25}
                          height={25}
                        />
                        <p>{editSeal.title}</p>
                      </div>
                    </div>
                  )}
                  <Button
                    variant="contained"
                    onClick={() => setOpenModalImage(true)}
                  >
                    Alterar selo
                  </Button>
                </Container>
              </Grid>
              <DetailsSeal seal={editSeal} setSeal={setEditSeal} isEdit />
            </DialogContent>
          </Dialog>

          <Dialog
            open={openModalImport}
            onClose={() => setOpenModalImport(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={style.modalPreviewSeal}
          >
            <DialogContent className={style.containerModalContent}>
              <Button
                className={style.modalClose}
                onClick={() => setOpenModalImport(false)}
              >
                <Close />
              </Button>
              <h2>{editSeal.title}</h2>
              <div className={style.containerActionsSeal}>
                <div data-element="add-products">
                  <label htmlFor="add-products">
                    <input
                      type="file"
                      id="add-products"
                      hidden
                      accept=".csv"
                      onChange={handleAddFlag}
                    />
                    <span>Adicionar Produtos</span>
                  </label>
                </div>
                <div data-element="exclude-seal">
                  <Button onClick={() => setOpenModalExcludeProducts(true)}>
                    Excluir Produtos
                  </Button>
                </div>
              </div>
              {loading && (
                <div className={style.loading}>
                  {Array.from({ length: 20 }).map((_, index) => (
                    <Skeleton
                      key={index}
                      className="skeleton"
                      style={{
                        borderRadius: 6,
                      }}
                      variant="rectangular"
                      width={280}
                      height={60}
                    />
                  ))}
                </div>
              )}

              {!loading && flags.length === 0 && (
                <p>Nenhum produto associado</p>
              )}
              {flags.length > 0 && !loading && (
                <ul className={style.containerFlagsEdit}>
                  {flags.map((flag) => (
                    <li key={flag.id} data-element="flag-edit">
                      <img
                        src={flag.image}
                        alt={flag.name}
                        width={40}
                        height={40}
                      />
                      <div data-element="flag-edit-info">
                        <p>{flag.name}</p>
                        <span>IDSKU: {flag.sku}</span>
                      </div>

                      <Button onClick={() => handleDeleteProduct(flag.sku)}>
                        <Close width={20} />
                      </Button>
                    </li>
                  ))}
                </ul>
              )}
            </DialogContent>
          </Dialog>

          <Dialog
            open={openModalExcludeProducts}
            onClose={() => setOpenModalExcludeProducts(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={style.modalChangeSeal}
            maxWidth="xs"
          >
            <DialogContent>
              <Button
                className={style.modalClose}
                onClick={() => setOpenModalExcludeProducts(false)}
              >
                <Close />
              </Button>
              <Grid className={style.wrapperSealExclud}>
                <Container className={style.containerChangeSeal}>
                  <h3>Excluir produtos</h3>
                  <p>
                    Ao adicionar a planilha os produtos serão excluidos. Tem
                    certeza que deseja continuar.
                  </p>
                  <div />

                  <div data-element="change-seal-action">
                    <Button
                      variant="contained"
                      data-element="change-seal-cancel"
                      onClick={() => setOpenModalExcludeProducts(false)}
                    >
                      Cancelar
                    </Button>
                    <label
                      htmlFor="exclude-seal"
                      data-element="change-seal-accept"
                    >
                      <input
                        type="file"
                        id="exclude-seal"
                        hidden
                        accept=".csv"
                        onChange={handleExcludeFlag}
                      />
                      <span>Continuar</span>
                    </label>
                  </div>
                </Container>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            open={openModalImage}
            onClose={() => setOpenModalImage(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={style.modalChangeSeal}
            maxWidth="xs"
          >
            <DialogContent>
              <Button
                className={style.modalClose}
                onClick={() => setOpenModalImage(false)}
              >
                <Close />
              </Button>
              <Grid className={style.wrapperSealExclud}>
                <Container className={style.containerChangeSeal}>
                  <h3>Subistituir selo</h3>
                  <p>
                    O selo atual será subistituido. Tem certeza que deseja
                    continuar.
                  </p>
                  <div />

                  <div data-element="change-seal-action">
                    <Button
                      variant="contained"
                      data-element="change-seal-cancel"
                      onClick={() => setOpenModalImage(false)}
                    >
                      Cancelar
                    </Button>
                    <label
                      htmlFor="change-seal"
                      data-element="change-seal-accept"
                    >
                      <input
                        type="file"
                        hidden
                        accept=".jpg, .jpeg, .png"
                        id="change-seal"
                        onChange={(event) => {
                          const file = event.target.files[0];

                          setEditSeal({
                            ...editSeal,
                            image: file,
                          });

                          setOpenModalImage(false);
                        }}
                      />
                      <span>Continuar</span>
                    </label>
                  </div>
                </Container>
              </Grid>
            </DialogContent>
          </Dialog>
        </>
      )}
    </Dashboard>
  );
};

export default ListSeals;
